<template lang="pug">
  include /mixins
  div
    captcha.is-hidden-captcha(
      :key='"verify-captcha"'
      id='verify-captcha'
    )

    +b.ambassador-steps.tt-space_mb--6
      +b.ambassador-step(
        v-for='step in steps'
        :key='step'
        :class='{ "is-active": step === currentStep, "is-past": step < currentStep }'
      ) 0{{ step }}

    +b.VALIDATION-OBSERVER(
      ref="validator",
      v-slot="{ valid }",
      tag="form",
    )
      ui-loader(v-if='isLoad')

      template(v-for='stepConfig in form_fields[currentStep - 1]')
        component(
          :is='stepConfig.component'
          :ref='stepConfig.component'
          v-bind='getStepProps(stepConfig.component)'
          v-on='getStepEvents(stepConfig.component)'
        )
          template(v-slot:auth-btn)
            slot(name='auth-btn')

      .relative
        +b.non-field-error-label.LABEL(v-if="non_field_errors") {{ non_field_errors[0] }}

      +b.g-row--justify_between.tt-space_mt--5.tt-space_pt--4-xl
        +b.g-cell.g-cols--12
          +b.tt-button--bordered_modern.BUTTON(
            type='submit'
            :disabled='isLoad',
            @click.prevent='goNext(valid)'
          )
            +e.title.P {{ currentStepConfig.actionLabel }}

    slot(name='register-btn')
</template>
<script>
import { tokenObtainRequest, make2FactorRequest } from '@api/auth.service'
import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'
import StepPhone from '@app/Auth/Steps/Phone'
import StepOtp from '@app/Auth/Steps/Otp'

export default {
  name: 'VerifyNew',
  mixins: [FormMixin],
  components: { StepPhone, StepOtp },
  props: {
    noRedirect: {
      default: false,
    },
  },
  data() {
    return {
      steps: [1, 2, 3, 4, 5],
      currentStep: 1,
      requestId: null,
      labels: {
        phone: this._('Телефон'),
      },
      form: {
        phone: '',
        code: '',
        is_new_user: true,
      },
      isLoad: false,
      non_field_errors: '',
      errorCode: '',
      offer: window.offer,
      rules: window.rules,
      localdata: {},
      form_fields: [
        [{ component: 'StepPhone', actionLabel: this._('Зарегистироваться') }],
        [{ component: 'StepOtp', actionLabel: this._('Подтвердить') }],
      ],
    }
  },

  computed: {
    currentStepConfig() {
      const configs = this.form_fields[this.currentStep - 1]
      return (configs && configs[0]) || {}
    },
  },

  methods: {
    getStepProps(component) {
      const props = {
        StepPhone: {
          phone: this.form.phone,
          offer: this.offer,
          rules: this.rules,
          labels: this.labels,
        },
        StepOtp: {
          phone: this.form.phone,
          code: this.form.code,
          isLoad: this.isLoad,
          errorCode: this.errorCode,
        },
      }
      return props[component] || {}
    },

    getStepEvents(component) {
      const events = {
        StepPhone: {
          'update:phone': val => { this.form.phone = val },
        },
        StepOtp: {
          'update:code': val => { this.form.code = val },
          'change-phone': () => { this.currentStep = 1 },
          resend: () => this.sendOtp(true),
        },
      }
      return events[component] || {}
    },

    getStepOtpRef() {
      const ref = this.$refs.StepOtp
      return Array.isArray(ref) ? ref[0] : ref
    },

    async goNext(valid) {
      if (this.currentStep === 1) {
        await this.sendOtp()
      } else {
        await this.confirmOtp()
      }
    },

    getEnterpriseToken() {
      return new Promise(resolve => {
        if (!window.grecaptcha || !window.grecaptcha.enterprise || !window.enterprise_recaptcha) {
          resolve(null)
          return
        }
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(
              window.enterprise_recaptcha, { action: 'LOGIN' }
            )
            resolve(token)
          } catch (e) {
            resolve(null)
          }
        })
      })
    },

    async sendOtp(isResend = false) {
      if (!isResend) {
        const isValid = await this.$refs.validator.validate()
        if (!isValid) return
      }
      this.isLoad = true
      this.non_field_errors = ''
      try {
        const captchaToken = await this.getEnterpriseToken()
        console.log('>>>>>>>>>>>Token>>>>>>>>>>>', captchaToken);
        const payload = {
          token: this.form.phone,
          is_new_user: true,
          is_authcode: true,
        }
        if (captchaToken) {
          payload.enterprise_captcha = { token: captchaToken, action: 'LOGIN' }
        }
        const { id } = await make2FactorRequest.execute({}, payload)
        this.requestId = id
        this.currentStep = 2
        if (isResend) {
          this.form.code = ''
          const otp = this.getStepOtpRef()
          if (otp) otp.clearPin()
        }
      } catch (e) {
        if (e.json) {
          e.json().then(body => {
            const errors = {}
            body.errors.forEach(error => {
              if ('request' === error.domain && error.state) {
                Object.assign(errors, error.state)
              }
            })
            const [first] = Object.keys(errors)
            if (first) {
              this.non_field_errors = [errors[first][0].message]
            }
          })
        }
      } finally {
        this.isLoad = false
      }
    },

    async confirmOtp() {
      const isValid = await this.$refs.validator.validate()
      if (!isValid) return
      this.errorCode = ''
      this.localdata = {
        username: this.requestId,
        password: this.form.code,
      }
      await this.submit(true, this.form)
    },

    async send() {
      return tokenObtainRequest.execute({}, this.localdata).then(
        () => {
          window.location.href = '/profile/onboarding/'
        },
        () => {
          this.form.code = ''
          this.errorCode = this._('Неверный код')
          const otp = this.getStepOtpRef()
          if (otp) otp.clearPin()
        }
      )
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.non_field_errors = parsed.non_field_errors
    },
  },
}
</script>